import React, { useState } from 'react';
import RadiographsPage from './RadiographsPage';
import { AiImagingPage, DslrPage } from './AdvancedPagesBundle';

// ImagingHubPage consolidates Radiographs + AI Imaging + DSLR Photos into
// one workspace. All three are clinical images of the patient — they belong
// together. Mirrors the PharmacyPage / WhatsAppHubPage pattern.
const IMAGING_TABS = [
  { key: 'radiographs', label: 'Radiographs',  render: (props) => <RadiographsPage {...props} /> },
  { key: 'ai-imaging',  label: 'AI Imaging',   render: (props) => <AiImagingPage {...props} /> },
  { key: 'dslr',        label: 'DSLR Photos',  render: (props) => <DslrPage {...props} /> },
];

const LEGACY_MAP = {
  'radiographs': 'radiographs',
  'ai-imaging':  'ai-imaging',
  'dslr':        'dslr',
};

const ImagingHubPage = ({ API_BASE, initialTab = 'radiographs', lockedPatientId = null }) => {
  const [tab, setTab] = useState(LEGACY_MAP[initialTab] || initialTab);
  const Active = IMAGING_TABS.find(t => t.key === tab) || IMAGING_TABS[0];

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {IMAGING_TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{
              padding: '9px 20px', borderRadius: 8, border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: '0.86rem',
              backgroundColor: tab === t.key ? '#0582ca' : '#e9ecef',
              color: tab === t.key ? 'white' : '#555',
            }}>
            {t.label}
          </button>
        ))}
      </div>
      {Active.render({ API_BASE, lockedPatientId })}
    </div>
  );
};

export default ImagingHubPage;
